import { isEmpty } from './isEmpty';

/**
 * @memberof module:util
 * @function
 * @name showBlurCards
 * @description Whether to show blur cards in results section on search page.
 *
 * @param {Object} seaFCLJSON - FCL json
 * @param {Object} seaLCLJSON - LCL json
 * @param {Object} airJSON - AIR json
 * @returns {boolean}
 *
 * @example
 * console.log(showBlurCards(
 * {..., show_blur_cards: true, ...},
 * {},
 * {}
 * )); //true
 *
 * console.log(showBlurCards({}, {}, {})); //false
 */

export const showBlurCards = (seaFCLJSON, seaLCLJSON, airJSON) => {
  const showBlurCards =
    (!isEmpty(seaFCLJSON) && !!seaFCLJSON.show_blur_cards) ||
    (!isEmpty(seaLCLJSON) && !!seaLCLJSON.show_blur_cards) ||
    (!isEmpty(airJSON) && !!airJSON.show_blur_cards) ||
    false;

  return showBlurCards;
};
